import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@bliks-io/ui';
import { TermsContentDe } from './termsContentDe';
import { TermsContentEn } from './termsContentEn';

export function TermsContent() {
  const { i18n, t } = useTranslation();
  const isGerman = i18n.language.startsWith('de');
  const isFallback = !isGerman && !i18n.language.startsWith('en');

  return (
    <>
      {isFallback && (
        <Alert className="mb-4">
          <AlertDescription>{t('termsLanguageFallbackNotice')}</AlertDescription>
        </Alert>
      )}
      {isGerman ? <TermsContentDe /> : <TermsContentEn />}
    </>
  );
}
